import operationTypes from 'constants/operationTypes';

export const rollbackValidOperations = [
  operationTypes.CAPITAL_INCREASE,
  operationTypes.CAPITAL_DECREASE,
  operationTypes.SELL_PARTICIPATION,
  operationTypes.DONATION,
  operationTypes.HERITAGE,
  operationTypes.ENDORSEMENT,
  operationTypes.TRANSMISSION,
  operationTypes.RECLASSIFICATION,
  operationTypes.DIVIDENDS_DISTRIBUTION,
  operationTypes.CONTRIBUTION,
];
